/**
 * This file provides backward compatibility exports for components
 * that still rely on the old MyContext interface.
 *
 * Instead of changing imports in all components at once, they can import from
 * this file, which will make future migration easier.
 */

import {
  CompatibilityContext,
  MyContext,
} from '../provider/CompatibilityProvider';

// Re-export the compatibility context as AuthContext for backward compatibility
export const AuthContext = CompatibilityContext;
export type { MyContext };
